const React = require('react');
const ReactDOM = require('react-dom');

function getContainerElement() {
    if (window && window.document) {
        const containerElement = document.createElement('div');
        containerElement.classList.add('loyaltyEnrollmentPromptContainer');
        document.body.appendChild(containerElement);
        return containerElement;
    } else {
        return null;
    }
}

function loadEnrollmentPromptRenderer() {
    return new Promise((resolve, reject) => {
        require.ensure(
            './EnrollmentPromptRenderer',
            () => {
                try {
                    const EnrollmentPromptRenderer = require('./EnrollmentPromptRenderer').default;
                    resolve(EnrollmentPromptRenderer);
                } catch (error) {
                    console.warn('Failed to load EnrollmentPromptRenderer. Error:', error);
                    reject(error);
                }
            },
            'EnrollmentPromptRenderer'
        );
    });
}

export function showLoyaltyEnrollmentPrompt(props) {
    return new Promise((resolve, reject) => {
        loadEnrollmentPromptRenderer()
            .then(EnrollmentPromptRenderer => {
                ReactDOM.render(<EnrollmentPromptRenderer {...props} />, getContainerElement());
                resolve({ enrollmentPromptShown: true });
            })
            .catch(error => {
                console.warn('Load of loyalty prompt failed', error);
                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./assets/js/trade/loyaltyEnrollmentPrompt/enrollmentPromptLoader.jsx